import React from 'react'

const Random = () => {
  return (
    <div>
        Random Component
    </div>
  )
}

export default Random
